import { LoadingButton } from '@mui/lab';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Button,
  Alert,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';

import { useResendDocument } from '@features/digitalOnboarding/hooks/useResendDocument';
import  CloseIcon  from '@mui/icons-material/Close';
import { ResendIcon } from '../../../../vectors/index';
import { Done } from '@mui/icons-material';

type ResendDocumentModalProps = {
  handleClose: () => void;
  applicationId: number;
  templateId: number | null;
};

const ResendDocumentModal: FC<ResendDocumentModalProps> = ({
  handleClose,
  applicationId,
  templateId,
}) => {
  const [errorText, setErrorText] = useState('');
  const { sendDocument, isSendingDocument } = useResendDocument({ setErrorText });

  const handleSend = () =>{
   templateId && sendDocument(
      { application_id: applicationId, template_ids: [templateId] },
      {
        onSuccess: () => {
          toast.success('Document sent to the applicant');
          handleClose();
        },
      },
    );
}
  return (
    <Dialog
      open={Boolean(templateId)}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', right: 8, top: 8 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap="10px"
        >
          <ResendIcon />
          <Typography variant="h5">
            Are you sure you want to resend this document?
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        {errorText && <Alert severity="error">{errorText}</Alert>}
        <Stack spacing={2}>
          <LoadingButton
            variant="contained"
            startIcon={<Done/>}
            loading={isSendingDocument}
            onClick={handleSend}
          >
            Yes resend this document
          </LoadingButton>
          <Button startIcon={<CloseIcon/>} color="secondary" variant="outlined" onClick={handleClose}>
            No, Go Back
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ResendDocumentModal;
